// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3hrW6";
var _4 = "options-1pvgE";
var _5 = "included_block-3XZAV";
var _6 = "upgrade_block-3hVJU";
var _7 = "header-4YN7A";
var _8 = "body-3-SVJ";
var _9 = "footer-2kawS";
var _a = "fare_family-2FVn3";
var _b = "options_withoutUpgrade-3r_r2";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "options", _5 as "included_block", _6 as "upgrade_block", _7 as "header", _8 as "body", _9 as "footer", _a as "fare_family", _b as "options_withoutUpgrade" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "options": _4, "included_block": _5, "upgrade_block": _6, "header": _7, "body": _8, "footer": _9, "fare_family": _a, "options_withoutUpgrade": _b }
